export default "__VITE_ASSET__b839ebd9__"